import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { AuthActions, StatusActions } from '../../store';
import { Stage, State } from '../../interfaces';
import { OFFERS_V2_TIMEOUT } from '../../constants';

@Component({
  selector: 'fin-upgrade-loading',
  templateUrl: 'loading.component.html',
})
export class LoadingComponent implements OnInit, OnDestroy {
  constructor(private store$: Store<State>) {}

  timer: ReturnType<typeof setTimeout>;

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload(): void {
    this.store$.dispatch(AuthActions.logout());
  }

  ngOnInit(): void {
    /**
     * If the user reloads the page whilst loading it will get stuck as no API request will
     * complete. This is a final fallback so that it will go back to the login screen if this
     * happens.
     */
    this.timer = setTimeout(() => {
      this.store$.dispatch(AuthActions.logout());
      this.store$.dispatch(StatusActions.setStage({ stage: Stage.LOGIN }));
      this.timer = undefined;
    }, OFFERS_V2_TIMEOUT);
  }

  ngOnDestroy(): void {
    window.clearTimeout(this.timer);
    this.timer = undefined;
  }
}
